import { MessageSquareTextIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const MessageSquareText = /* @__PURE__ */ createIcon(MessageSquareTextIcon, 'MessageSquareText');
